import React, {useEffect, useRef, useState} from "react";
import {
    AverageOrderTimeRow,
    AvgDeliveryTimeImg,
    AvgOrderTimeLabel,
    AvgOrderTimeValue,
    DeliveryStatsBlock,
    DeliveryStatsIcon,
    DeliveryStatsLabel,
    DeliveryStatsRow,
    DeliveryStatsValue,
    StatsHeader,
    Wrapper
} from "./OrderStats.styles";
import {useHistory} from "react-router-dom";
import AvgDeliveryTimeIcon from "../../../../public/images/avg-delivery-time-icon.svg";
import ActiveOrderIcon from "../../../../public/images/active-order-icon.svg";
import WaitingOrderIcon from "../../../../public/images/waiting-order-icon.svg";
import CanceledOrderIcon from "../../../../public/images/canceled-order-icon.svg";
import DeliveredOrderIcon from "../../../../public/images/delivered-order-icon.svg";
import TotalOrderIcon from "../../../../public/images/total-order-icon.svg";
import {Spin} from "antd";
import {useFetch, useStore, useIsFocused} from "@vigo/hooks";
import {TimeRangeFilter} from "./timeRangeFilter/TimeRangeFilter";
import {isNumeric} from "../../../../utils/helpers";
import moment from "moment/moment";

const RELOAD_INTERVAL = 1000 * 10; //10 seconds

export const OrderStats = ({
    dateType: propDateType,
    startDate: propStartDate,
    endDate: propEndDate,
    onDateChange
}) => {
    const stores = useStore();
    const history = useHistory();
    const isFocused = useIsFocused();

    // Prop'lardan gelen değerleri kullan, yoksa default değerleri kullan
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [dateType, setDateType] = useState(propDateType || "daily");

    // Alt firma bilgilerini al
    const selectedSubCompanyId = stores.meStore.selectedSubCompanyId;
    const selectedSubCompanies = React.useMemo(() => {
        return selectedSubCompanyId ? [selectedSubCompanyId] : [];
    }, [selectedSubCompanyId]);

    // Prop'lar değiştiğinde local state'i güncelle
    useEffect(() => {
        if (propStartDate !== undefined) setStartDate(propStartDate);
        if (propEndDate !== undefined) setEndDate(propEndDate);
        if (propDateType !== undefined) setDateType(propDateType);
    }, [propStartDate, propEndDate, propDateType]);

    const [recall, setRecall] = useState(true);
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const [loading, statsData, _, __] = useFetch({
        fetchFn: stores.statisticStore.getHistoricStatistics.bind(null, {
            period: dateType,
            city: "",
            startDate: startDate,
            endDate: endDate,
            subcompanies: selectedSubCompanies.join("|")
        }),
        defaultDataValue: {},
        initialCall: false,
        dependencies: [recall, dateType, startDate, endDate, selectedSubCompanyId]
    });

    useEffect(() => {
        setTimeout(() => {
            setRecall(!recallRef.current);
        }, 200);
    }, []);

    useEffect(() => {
        if (isFocused) {
            let timeout = null;

            timeout = setTimeout(() => {
                setRecall(!recallRef.current);
            }, RELOAD_INTERVAL);

            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    const nullObjectCheck = obj => {
        return JSON.stringify(obj) === JSON.stringify({});
    };
    const renderAvgDeliveryTime = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.averageDeliveryTime)) {
            return "- dk";
        }
        if (statsData?.averageDeliveryTime > 35) {
            return `35+ dk`;
        }
        return `${statsData?.averageDeliveryTime} dk`;
    };

    const renderActiveOrderCount = () => {
        if (loading || nullObjectCheck(statsData) || !isNumeric(statsData?.onTheWayOrdersCount)) {
            return "";
        }
        return statsData?.onTheWayOrdersCount;
    };

    const renderWaitingOrderCount = () => {
        if (loading || nullObjectCheck(statsData) || !isNumeric(statsData?.inQueueOrdersCount)) {
            return "";
        }
        return statsData?.inQueueOrdersCount;
    };

    const renderCanceledOrderCount = () => {
        if (loading || nullObjectCheck(statsData) || !isNumeric(statsData?.canceledOrdersCount)) {
            return "";
        }
        return statsData?.canceledOrdersCount;
    };

    const renderDeliveredOrderCount = () => {
        if (loading || nullObjectCheck(statsData) || !isNumeric(statsData?.deliveredOrdersCount)) {
            return "";
        }
        return statsData?.deliveredOrdersCount;
    };

    const renderTotalOrderCount = () => {
        if (loading || nullObjectCheck(statsData) || !isNumeric(statsData?.totalOrderCount)) {
            return "";
        }
        return statsData?.totalOrderCount;
    };

    return (
        <Wrapper>
            <StatsHeader>
                <AverageOrderTimeRow>
                    <AvgOrderTimeLabel>
                        <AvgDeliveryTimeImg src={AvgDeliveryTimeIcon} />
                        Ortalama Teslimat Süresi
                    </AvgOrderTimeLabel>
                    <AvgOrderTimeValue>
                        {loading ? <Spin /> : renderAvgDeliveryTime()}
                    </AvgOrderTimeValue>
                </AverageOrderTimeRow>
                {!onDateChange && (
                    <TimeRangeFilter
                        dateType={dateType}
                        selectFieldOnChange={value => {
                            if (value === "daily") {
                                setStartDate(moment().format("YYYY-MM-DD"));
                                setEndDate(moment().format("YYYY-MM-DD"));
                            } else if (value === "weekly") {
                                setStartDate(
                                    moment()
                                        .subtract(1, "week")
                                        .format("YYYY-MM-DD")
                                );
                                setEndDate(moment().format("YYYY-MM-DD"));
                            } else if (value === "monthly") {
                                setStartDate(
                                    moment()
                                        .subtract(1, "month")
                                        .format("YYYY-MM-DD")
                                );
                                setEndDate(moment().format("YYYY-MM-DD"));
                            } else if (["choose", ""].includes(value)) {
                                setStartDate("");
                                setEndDate("");
                            }
                            setDateType(value);
                        }}
                        rangePickerOnChange={formatString => {
                            setStartDate(formatString[0]);
                            setEndDate(formatString[1]);
                        }}
                    />
                )}
            </StatsHeader>

            <DeliveryStatsRow gutter={16}>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push("/musteri/siparislerim?page=1&city=all&orderType=current");
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={ActiveOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderActiveOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Aktif Paket Sayısı</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push("/musteri/siparislerim?page=1&city=all&orderType=inQueue");
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={WaitingOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderWaitingOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Bekleyen Paket Sayısı</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push(
                            "/musteri/siparislerim?page=1&city=all&orderType=past&deliveryStatus=canceled"
                        );
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={CanceledOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderCanceledOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>İptal Paket Sayısı</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push("/musteri/siparislerim?page=1&city=all&orderType=past");
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={DeliveredOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderDeliveredOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Tamamlanmış Paket Sayısı</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock span={4} style={{marginBottom: "16px"}}>
                    <DeliveryStatsIcon src={TotalOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderTotalOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Toplam Paket Sayısı</DeliveryStatsLabel>
                </DeliveryStatsBlock>
            </DeliveryStatsRow>
        </Wrapper>
    );
};
